import { useTranslations } from '@vocab/react';
import { Actions, type Button, IconAdd, ButtonLink } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import { events } from 'src/modules/analyticsTracker';
import { getCreateUrl } from 'src/utils/urls';

import translations from './.vocab';

type ButtonProps = ComponentProps<typeof Button>;

interface Props {
  tone?: ButtonProps['tone'];
  variant?: ButtonProps['variant'];
}

const CreateBrandButton = ({ tone, variant }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Actions>
      <ButtonLink
        tone={tone}
        variant={variant}
        href={getCreateUrl()}
        data-testid="create-brand-button"
        data-analytics={events.CREATE_NEW_BRAND_CLICKED}
      >
        {t('Create new brand')} <IconAdd alignY="lowercase" />
      </ButtonLink>
    </Actions>
  );
};

export default CreateBrandButton;
